import CreditsRowDesktop from './CreditsRowDesktop';

export default CreditsRowDesktop;
